import { TableSortLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
    color: theme.palette.text.primary,
    ":hover": {
        color: theme.palette.text.primary,
    },
}));

export { PeekTableSortLabel, PeekTableSortLabel as default };
